import React, { useEffect, useState } from "react";
import StoreLayout from "../../components/Layout/StoreLayout";
import img from "../../assets/V2/svg/store-page.svg";
import '../comingSoon/comingSoon.css'
import { useStore } from "../../context/StoreContext";
import StoreSkeleton from "../../components/Loading/StoreSkeleton";

const StoreNotExist = () => {
    const [loading, setLoading] = useState(true);
    useEffect(() => {
      const timer = setTimeout(() => setLoading(false), 1500);
      return () => clearTimeout(timer);
    })
  return (
    <>
      <StoreLayout>
         {loading ? <StoreSkeleton /> : (
        <div className="main-page">
          <div>
            <img src={img} alt="Store Not Exist" />
          </div>
          <div className="fs34 fw600 neutral-color mt-5">
            The store does not exist.
          </div>
        </div>
         )}
      </StoreLayout>
    </>
  );
};

export default StoreNotExist;